<template>
  <div @click="$emit('click')" :class="{'td3-body-bg':tdType == 'body'}" class="my-td3-box" ref="box" :tdWidth="tdWidth">
    <div class="my-td3-box-inner" ref="td" :class="{'overflow':overflow}">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Td3',
  props: {
    tdType: {
      type: String,
      default: 'body'
    },
    showOverflow: {
      type: Boolean,
      default: true
    },
    tdWidth: {
      type: Number
    }
  },
  computed: {

  },
  data () {
    return {
      overflow: false
    }
  },

  methods: {
    init () {
      this.$nextTick(function () {
        let td = this.$refs.td
        let height = window.getComputedStyle(td).height
        let num = height.substr(0, height.length - 2)
        if (Number(num) > 20 && this.showOverflow) {
          this.overflow = true
          td.title = td.innerHTML
        }
      }.bind(this))
    }
  },
  mounted () {

  },
  destroyed () {

  },
  updated () {

  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

.my-td3-box{
  // width: 100%;
  border-right: 1px solid #e4e7ed;
  &:last-child{
    border-right:none;
  }
  vertical-align: top;
  box-sizing:border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  font-size:14px;
  display: inline-block;
  line-height: 18px;
  padding: 13px 0px;
  margin: 0 auto;
  min-height: 44px;
  .my-td3-box-inner{
    width: 100%;
    display: inline-block;
    box-sizing:border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    padding: 0 20px;

    white-space:normal;
    word-break:break-all;

    // white-space:normal;
    // word-break:break-all;
    // overflow:hidden;

    // width:200px;
  }
  .overflow {
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
    -webkit-box-orient: vertical !important;

    overflow: hidden !important;
    text-overflow: ellipsis !important;
    -webkit-line-clamp: 1 !important;

    white-space: nowrap !important;
    // white-space:normal;
    word-break:normal !important;
  }
}

</style>
